import { Injectable } from '@angular/core';



export enum LegalRepresentationState {
  SemRepresentancaoLegal,
  AguardaValidacaoDaCGA,
  RepresentacaoDeferida,
  RepresentaçaoAguardarDocumentos,
  RepresentaçaoEmAudienciaPrevia,
  RepresentaçaoIndeferida,
  AIndeferir

}

@Injectable({ providedIn: "root" })


export class LegalRepresentationStateService {



  public getStateColor(state: string): string {
    let result = null;
    const stateInt = parseInt(state); 
    switch (stateInt) {
      case LegalRepresentationState.SemRepresentancaoLegal:
        result = 'transparent !important'; // Trasparente
        break;
      case LegalRepresentationState.AguardaValidacaoDaCGA:
        result = 'var(--bs - gray) !important'; // Cinzento 
        break;
      case LegalRepresentationState.RepresentacaoDeferida:
        result = '#8EC24B !important'; // Verde
        break;
      case LegalRepresentationState.RepresentaçaoAguardarDocumentos:
        result = '#FFF000 !important'; // Amarelo
        break;
      case LegalRepresentationState.RepresentaçaoEmAudienciaPrevia:
        result = '#FE5C2D !important'; // Laranja
        break;
      case LegalRepresentationState.RepresentaçaoIndeferida:
        result = '#FF1900 !important'; // Vermelho
        break;
      case LegalRepresentationState.AIndeferir:
        result = 'var(--bs - gray) !important'; // Cinzento 
        break;
      default:
        result = 'transparent !important';
        break;
    }

    return result;
  }

  public getStateText(state: string): string {
    let result = null;
    const stateInt = parseInt(state); 
    switch (stateInt) {
      case LegalRepresentationState.SemRepresentancaoLegal:
        result = ''; //Sem representanção legal
        break;
      case LegalRepresentationState.AguardaValidacaoDaCGA:
        result = 'Aguarda Validação da CGA';
        break;
      case LegalRepresentationState.RepresentacaoDeferida:
        result = 'Representação Deferida';
        break;
      case LegalRepresentationState.RepresentaçaoAguardarDocumentos:
        result = 'Representação a Aguardar Documentos';
        break;
      case LegalRepresentationState.RepresentaçaoEmAudienciaPrevia:
        result = 'Representação em Audiencia Prévia';
        break;
      case LegalRepresentationState.RepresentaçaoIndeferida:
        result = 'Representação Indeferida';
        break;
      case LegalRepresentationState.AIndeferir:
        result = 'Em análise CGA';
        break;
      default:
        result = '';
        break;
    }
    return result;
  }

  public getStateIcon(state: string): string {
    let result = null;
    const stateInt = parseInt(state); 
    switch (stateInt) {
      case LegalRepresentationState.SemRepresentancaoLegal:
        result = ''; //Sem representanção legal
      case LegalRepresentationState.AguardaValidacaoDaCGA:
        result = 'icon-ok';
        break;
      case LegalRepresentationState.RepresentacaoDeferida:
        result = 'icon-help';
        break;
      case LegalRepresentationState.RepresentaçaoAguardarDocumentos:
        result = 'icon-error';
        break;
      case LegalRepresentationState.RepresentaçaoEmAudienciaPrevia:
        result = 'icon-add';
        break;
      case LegalRepresentationState.RepresentaçaoIndeferida:
        result = 'icon-user Indiferida';
        break;

      default:
        result = 'icon-info';
        break;
    }
    return "icon-user";
  }

  public getStateDeferido(hasRL: boolean, stateRL: string): boolean {
    // Test parameters for null
    if (hasRL == null || hasRL == undefined) {
      return true;
    }
    if (stateRL == null || stateRL == undefined) {
      return true;
    }

    let result = hasRL;
    if (!hasRL) {
      return true;
    }

    return stateRL == LegalRepresentationState.RepresentacaoDeferida.toString();
  }

  getStateIndeferido(hasRL: boolean, stateRL: string) {
    // Test parameters for null
    if (hasRL == null || hasRL == undefined) {
      return false;
    }
    if (stateRL == null || stateRL == undefined) {
      return false;
    }

    let result = hasRL;
    if (!hasRL) {
      return false;
    }

    return stateRL == LegalRepresentationState.RepresentaçaoIndeferida.toString();
  }
}

